export interface ModalLayoutProps {
  title?: string;
  content?: string;
  onConfirm?: () => void;
  onResume?: () => void;
  onClose?: () => void;
  onAfterClose?: () => void;
  primaryButtonText?: string;
  secondaryButtonText?: string;
}
